module.exports = __webpack_public_path__ + "dae11ec693fb32c6574aa13a672c88f4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/social/og.png
// module id = 501
// module chunks = 0